import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import request from '@/utils/request'
import auth from '@/utils/auth'
// import 'lib-flexible'
// import style
import '@/assets/common.css'    // 使用 CSS

// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

import GeminiScrollbar from 'vue-gemini-scrollbar'
Vue.use(GeminiScrollbar)

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

Vue.config.productionTip = false


// Vant修改为按需引入
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
import { Lazyload } from 'vant'
Vue.use(Lazyload)

const authH5 = async () => {
  console.log()
  if (store.state.token) {
    const refreshed = await auth.refreshToken()
    if (refreshed) {return}
  }
  await auth.wxAuthorize()
}

const initData = async () => {

  // 初始化当前用户信息
  await request.get('/api/account/rest_account').then((res) => store.commit('setCurrent', res))
  let {nickname} = store.state.current
  if(!nickname){
    console.log('请求授权')
    auth.refreshUserInfoAuthorize()
  }

  // const { role } = store.state.current
  // if (role && role >= 1 && role <= 2) {await request.get(`/api/farming/rest_rel/${role}`).then((res) => store.commit('setManagerInfo', res))}
}

const init = async () => {
  //验证
  await authH5()
  await initData()
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
}
init()
